import type { BaseEntity } from '@/models/BaseEntity'
import { type OperandType } from '@/models/Enums/Operand'
import { type SelectModel, type SelectModelEntry } from '@/models/utils'
import { t } from '@/i18n'

export interface Zeitgrenzen extends BaseEntity {
  operand1: OperandType
  einheit1: ZeitEinheit
  wert1: number
  operand2?: OperandType
  einheit2?: ZeitEinheit
  wert2?: number
}

export enum ZeitEinheit {
  Tage,
  Wochen,
  Monate,
  Jahre
}

export const zeitEinheitSelectValues: SelectModel<ZeitEinheit> = [
  { name: t('time.days'), code: ZeitEinheit.Tage },
  { name: t('time.weeks'), code: ZeitEinheit.Wochen },
  { name: t('time.months'), code: ZeitEinheit.Monate },
  { name: t('time.years'), code: ZeitEinheit.Jahre }
]

export const parseZeitEinheitIndex = (zeitEinheit?: SelectModelEntry<ZeitEinheit>) => {
  if (!zeitEinheit) return undefined
  const index = zeitEinheitSelectValues.findIndex((z) => z.name === zeitEinheit.name)
  return index !== -1 ? index : undefined
}
export const toZeitEinheitModel = (zeitEinheit?: ZeitEinheit) =>
  zeitEinheitSelectValues.find((z) => z.code === zeitEinheit)
